export class RecupererEtEnregistrerEncaissementsResultat {
    constructor() {
        this.nombreEncaissementsAjoutes = 0;
        this.nombreEncaissmentsEnErreur = 0;
    }

    public nombreEncaissementsAjoutes: number;
    public nombreEncaissmentsEnErreur: number;
}
